module.exports = __webpack_public_path__ + "img/img17.099337ea.svg";